import { render, staticRenderFns } from "./myFeedBack.vue?vue&type=template&id=9d379366&scoped=true&"
import script from "./myFeedBack.vue?vue&type=script&lang=js&"
export * from "./myFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./myFeedBack.vue?vue&type=style&index=0&id=9d379366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d379366",
  null
  
)

export default component.exports